import { Directive, OnDestroy, OnInit, inject } from '@angular/core';
import { AbstractControl, NgControl } from '@angular/forms';
import { Observable, Subject } from 'rxjs';
import { HasErrorDirective } from './has-error.directive';

const extractTouchedChanges = (control: AbstractControl): Observable<boolean> => {
    const prevMarkAsTouched = control.markAsTouched.bind(control);
    const prevMarkAsUntouched = control.markAsUntouched.bind(control);

    const touchedChanges$ = new Subject<boolean>();

    function nextMarkAsTouched(...args: any) {
        prevMarkAsTouched(...args);
        touchedChanges$.next(true);
    }

    function nextMarkAsUntouched(...args: any) {
        prevMarkAsUntouched(...args);
        touchedChanges$.next(false);
    }

    control.markAsTouched = nextMarkAsTouched;
    control.markAsUntouched = nextMarkAsUntouched;

    return touchedChanges$;
};

@Directive({
    // eslint-disable-next-line @angular-eslint/directive-selector
    selector: '[formControl], [formControlName]',
    exportAs: 'formControl',
})
export class RichFormControlDirective implements OnInit, OnDestroy {
    control = inject(NgControl, { self: true });
    private readonly hasErrorController = inject(HasErrorDirective, { optional: true, host: true });

    public touched$!: Observable<boolean>;

    private unsubscriber: () => void = () => {};

    public ngOnInit(): void {
        this.touched$ = extractTouchedChanges(this.control.control);
        this.unsubscriber = this.hasErrorController?.registerNgControl(this);
    }

    public ngOnDestroy(): void {
        if (this.unsubscriber) {
            this.unsubscriber();
        }
    }
}
